/* LE LOT : le sous-total suit les menus, et le bouton ajoute les trois lignes.
 *
 * ⛔ TROIS LIGNES DE PRODUITS NORMAUX, PAS UN PRODUIT « LOT » (Adrien, 24/08/2026). Le prix et le
 * stock restent ceux des fiches, et l'atelier voit trois affiches a imprimer. L'attribut de ligne
 * dit de quel lot elles viennent : c'est ce qui permettra plus tard de compter ce que les lots
 * rapportent, sans deviner.
 *
 * ⛔ LE SOUS-TOTAL SE CALCULE ICI, sur les variantes choisies. Un total ecrit en Liquid serait
 * celui du premier format de chaque affiche et mentirait des le premier changement de menu.
 *
 * ⚠️ LA REMISE AFFICHEE N'EST QU'UN ECHO. C'est Shopify qui l'applique, par une remise
 * automatique posee sur la collection du lot : ce que cette page montre doit donc etre le MEME
 * taux, sans quoi le panier annoncerait autre chose que la page. Le taux vient du reglage de
 * section, pas d'un nombre ecrit dans ce fichier.
 */
(function () {
  var lot = document.querySelector('[data-lot]');
  if (!lot) return;
  var cartes = [].slice.call(lot.querySelectorAll('[data-lotc]'));
  if (!cartes.length) return;

  var remise = Math.max(0, Math.min(100, parseFloat(lot.getAttribute('data-remise')) || 0));
  var elTotal = lot.querySelector('[data-lot-total]');
  var elPlein = lot.querySelector('[data-lot-plein]');
  var elBadge = lot.querySelector('[data-lot-badge]');
  var bouton = lot.querySelector('[data-lot-ajouter]');
  var note = lot.querySelector('[data-lot-note]');

  /* ⛔ LE FORMAT VIENT DE LA BOUTIQUE, `window.MURMURE_MONEY_FORMAT`, pose par le gabarit du
     theme. Ma premiere version cherchait `window.themeMoneyFormat`, qui n'existe nulle part ici :
     le repli s'appliquait donc TOUJOURS et la page affichait « 32,13 EUR » la ou tout le site
     ecrit « 32,13 € ». Mesure sur la page servie.
     ⚠️ ET LE REPLI SUIT LA MONNAIE DU PANIER, pas l'euro : treize marches, et les montants en
     monnaie locale sont plus longs qu'en euro. */
  function sous(cents) {
    var f = window.MURMURE_MONEY_FORMAT;
    if (f) {
      var v = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      /* Le format de Shopify est un gabarit du genre « {{amount}} € » : on remplace le marqueur,
         quel que soit celui que la boutique emploie. */
      var rendu = String(f).replace(/\{\{\s*amount[_a-z]*\s*\}\}/g, v);
      if (rendu !== String(f)) return rendu;
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (lot.getAttribute('data-devise') || '');
  }

  /* ⛔ LES VARIANTES DU CADRE VIENNENT DE LA PAGE, on ne les devine pas. L'appariement se fait
     sur la TAILLE et la TEINTE, deux valeurs lues sur les selecteurs : ecrire « 50X70 / Noir » a
     la main ne marcherait pas sur les douze autres marches, ou Markets traduit la teinte. */
  var cadres = [];
  try { cadres = JSON.parse(lot.getAttribute('data-cadres') || '[]'); } catch (e) { cadres = []; }

  /* ⚠️ LE TITRE D'UNE VARIANTE DE CADRE EST « 50X70 / Noir ». On teste les deux morceaux plutot
     que la chaine entiere : le separateur et l'ordre appartiennent a Shopify, pas a nous. */
  function cadreDe(taille, teinte) {
    if (!taille || !teinte) return null;
    for (var i = 0; i < cadres.length; i++) {
      var t = String(cadres[i].t || '');
      if (t.indexOf(taille) >= 0 && t.indexOf(teinte) >= 0) return cadres[i];
    }
    return null;
  }

  function choix() {
    return cartes.map(function (c) {
      var s = c.querySelector('[data-lotc-variante]');
      var o = s && s.options[s.selectedIndex];
      var sc = c.querySelector('[data-lotc-cadre]');
      var sb = c.querySelector('[data-lotc-bordure]');
      var ob = sb && sb.options[sb.selectedIndex];
      var sf2 = c.querySelector('[data-lotc-fond]');
      var of2 = sf2 && sf2.options[sf2.selectedIndex];
      var taille = o ? (o.getAttribute('data-taille') || '') : '';
      var teinte = sc ? sc.value : '';
      var k = cadreDe(taille, teinte);
      return {
        id: s ? s.value : '',
        /* ⛔ DEUX PRIX SEPARES, ET CE N'EST PAS UN DETAIL DE CALCUL. La remise du lot est posee
           chez Shopify sur la COLLECTION, qui ne contient que les trois affiches : le cadre est
           un autre produit, il n'est pas remise. Un total remise en bloc annoncerait donc moins
           que ce que le panier facturera, et une annonce de prix qui ne tient pas se decouvre a
           l'ecran du paiement. */
        prixAffiche: o ? (parseInt(o.getAttribute('data-prix'), 10) || 0) : 0,
        prixCadre: k ? k.p : 0,
        cadre: k ? k.id : null,
        bordure: sb ? sb.value : '',
        bordureMot: sb ? (sb.getAttribute('data-mot') || 'Bordure') : '',
        bordureLib: ob ? (ob.getAttribute('data-libelle') || ob.textContent) : '',
        fond: sf2 ? sf2.value : '',
        fondMot: sf2 ? (sf2.getAttribute('data-mot') || '') : '',
        fondLib: of2 ? (of2.getAttribute('data-libelle') || of2.textContent) : '',
      };
    }).filter(function (x) { return x.id; });
  }

  function peindre() {
    var l = choix();
    var aff = l.reduce(function (a, x) { return a + x.prixAffiche; }, 0);
    var cad = l.reduce(function (a, x) { return a + x.prixCadre; }, 0);
    var t = aff + cad;
    if (!t) { elTotal.textContent = '…'; elPlein.hidden = true; elBadge.hidden = true; return; }
    /* ⛔ LA REMISE NE TOUCHE QUE LES AFFICHES, parce que c'est ce que la remise de Shopify fait.
       ⛔ ARRONDI AU CENTIME, ET DANS LE MEME SENS QUE SHOPIFY. Un demi-centime d'ecart entre la
       page et le panier se voit, et c'est une annonce de prix qui ne tient pas. */
    var apres = remise ? Math.round(aff * (100 - remise) / 100) + cad : t;
    elTotal.textContent = sous(apres);
    if (remise && apres < t) {
      elPlein.textContent = sous(t); elPlein.hidden = false;
      /* ⚠️ LE BADGE DIT LE TAUX DU LOT, PAS LA REMISE DU PANIER. Avec des cadres, la baisse
         reelle du total est plus faible que le taux : afficher « -15 % » a cote d'un total qui
         ne baisse que de 6 % ferait douter du chiffre le plus important de la page. On dit donc
         ce qui est remise, en toutes lettres. */
      /* ⚠️ DEUX MORCEAUX, COMME SUR LA FICHE : le taux en gras, puis ce sur quoi il porte. Le
         badge de la fiche a la meme structure, et c'est elle qui lui donne son allure. */
      var pct = elBadge.querySelector('[data-lot-badge-pct]');
      var rest = elBadge.querySelector('[data-lot-badge-rest]');
      if (pct) pct.textContent = '-' + remise + ' %';
      if (rest) rest.textContent = cad ? (lot.getAttribute('data-mot-cadres') || '') : '';
      elBadge.hidden = false;
    } else { elPlein.hidden = true; elBadge.hidden = true; }
  }

  /* ⚠️ LES TROIS MENUS COMPTENT DANS LE TOTAL : le format, la teinte de cadre et la bordure.
     N'ecouter que le premier laisserait un sous-total juste au chargement et faux ensuite. */
  /* ⛔ LES TROIS TEINTES SE RECONNAISSENT A LEUR RANG, JAMAIS A LEUR MOT. Les valeurs d'option
     sont traduites par Markets : sur /nl ce sont « Wit », « Zwart », « Licht eiken ». Chercher
     « Noir » ne rendrait rien et aucune moulure ne s'afficherait, sur douze marches, sans la
     moindre erreur. C'est la faute que la fiche produit a payee le 10/08/2026 ; le rang, lui, ne
     se traduit pas : blanc, noir, chene clair, dans l'ordre des options du produit cadre.
     ⚠️ LES TROIS COULEURS SONT CELLES DE LA FICHE (`FRAME_SWATCH` dans product.js) : une
     quatrieme nuance ici ferait deux moulures differentes pour un meme cadre. */
  var TEINTES = ['#F2EFE9', '#1A1A1A', '#D0AE79'];

  /* ⛔ L'APERCU MONTRE CE QUI SERA LIVRE. La marge blanche vient d'`AfBordure`, qui rejoue la
     regle de l'atelier ; on ne la recalcule pas. Si le module n'est pas encore charge, on ne
     dessine RIEN plutot qu'une marge inventee : une bordure fausse est pire qu'une bordure
     absente, c'est elle qui a valu l'avis a deux etoiles du 17/08/2026. */
  function apercu(c) {
    var cadreEl = c.querySelector('[data-lotc-apercu]');
    var mat = c.querySelector('[data-lotc-mat]');
    if (!cadreEl || !mat) return;
    var sv = c.querySelector('[data-lotc-variante]');
    var ov = sv && sv.options[sv.selectedIndex];
    var taille = ov ? (ov.getAttribute('data-taille') || '') : '';
    var sc = c.querySelector('[data-lotc-cadre]');
    var rang = sc ? sc.selectedIndex - 1 : -1;   // 0 = « Sans cadre »
    var sb = c.querySelector('[data-lotc-bordure]');
    var avec = sb ? sb.value === 'avec' : false;

    if (rang >= 0 && TEINTES[rang]) {
      cadreEl.style.borderWidth = '';
      cadreEl.style.borderColor = TEINTES[rang];
    } else {
      cadreEl.style.borderWidth = '0px';
      cadreEl.style.borderColor = 'transparent';
    }
    /* ⛔ LE NUANCIER NE S'OUVRE QU'AVEC LA BORDURE, comme sur la fiche : proposer une couleur de
       marge sur une affiche vendue a fond perdu ferait choisir une teinte qui ne partirait pas. */
    var sf = c.querySelector('[data-lotc-fond]');
    if (sf) sf.hidden = !avec;
    var of = sf && sf.options[sf.selectedIndex];
    var hex = of ? (of.getAttribute('data-hex') || null) : null;
    if (window.AfBordure && window.AfBordure.poserCadre) {
      window.AfBordure.poserCadre(mat, taille, avec, hex);
    }
  }

  cartes.forEach(function (c) {
    ['[data-lotc-variante]', '[data-lotc-cadre]', '[data-lotc-bordure]', '[data-lotc-fond]'].forEach(function (q) {
      var s = c.querySelector(q);
      if (s) s.addEventListener('change', function () { apercu(c); peindre(); });
    });
  });
  cartes.forEach(apercu);
  /* ⚠️ `bordure-blanche.js` est en `defer` comme ce fichier, et rien ne garantit l'ordre entre
     deux differes. On repasse une fois la page chargee : sans cela, la marge du premier rendu
     pouvait manquer sur un chargement froid, et seulement sur celui-la. */
  window.addEventListener('load', function () { cartes.forEach(apercu); });
  peindre();

  bouton.addEventListener('click', function () {
    var items = choix();
    if (items.length !== cartes.length) return;
    bouton.disabled = true;
    var dit = bouton.textContent;
    bouton.textContent = bouton.getAttribute('data-en-cours') || bouton.textContent;
    note.hidden = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items.reduce(function (acc, x) {
          var props = { _lot: lot.getAttribute('data-lot') };
          /* ⚠️ DEUX PROPRIETES POUR LA BORDURE, comme sur la fiche : le CODE que l'atelier lit
             (`_bordure`, masque au client) et le LIBELLE traduit que le client voit dans son
             panier. Une seule des deux laisserait soit l'atelier sans consigne, soit le client
             devant un mot technique. */
          if (x.bordure) {
            props._bordure = x.bordure;
            if (x.bordureMot) props[x.bordureMot] = x.bordureLib;
            /* ⛔ LA TEINTE NE PART QU'AVEC LA BORDURE, et seulement si elle n'est pas le papier.
               La valeur vide EST le papier : l'envoyer ferait encrer toute la marge de chaque
               commande que personne n'a demandee, et referait au passage tout le cache
               d'impression. */
            if (x.bordure === 'avec' && x.fond) {
              props._bordure_fond = x.fond;
              if (x.fondMot) props[x.fondMot] = x.fondLib;
            }
          }
          acc.push({ id: Number(x.id), quantity: 1, properties: props });
          /* ⛔ LE CADRE EST UNE LIGNE A LUI, rattachee au lot par le meme attribut : c'est ainsi
             que la fiche produit le vend, et deux facons de vendre le meme cadre finiraient par
             donner deux paniers differents pour le meme clic. */
          if (x.cadre) {
            acc.push({ id: Number(x.cadre), quantity: 1,
              properties: { _lot: lot.getAttribute('data-lot') } });
          }
          return acc;
        }, []),
      }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'refus du panier'); });
      /* ⛔ ON VA AU PANIER, ON N'ANNONCE PAS « AJOUTE » SUR PLACE. Trois lignes d'un coup se
         verifient : le client doit VOIR que la remise s'est appliquee, sinon il la cherche. */
      window.location.href = window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + 'cart' : '/cart';
    }).catch(function (e) {
      note.textContent = e.message; note.hidden = false;
      bouton.disabled = false; bouton.textContent = dit;
    });
  });
})();
